module.exports = { id: "triangle-down", url: "/build/app/img/symbols.svg#triangle-down", viewBox: "", toString: function() { return this.url; } };